import { render, staticRenderFns } from "./ShcDetails.vue?vue&type=template&id=7d53af24&scoped=true"
import script from "./ShcDetails.vue?vue&type=script&lang=js"
export * from "./ShcDetails.vue?vue&type=script&lang=js"
import style0 from "./ShcDetails.vue?vue&type=style&index=0&id=7d53af24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d53af24",
  null
  
)

export default component.exports